import { render, staticRenderFns } from "./FeesStructureInstallment.vue?vue&type=template&id=08dc1b1a&scoped=true&"
import script from "./FeesStructureInstallment.vue?vue&type=script&lang=js&"
export * from "./FeesStructureInstallment.vue?vue&type=script&lang=js&"
import style0 from "./FeesStructureInstallment.vue?vue&type=style&index=0&id=08dc1b1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08dc1b1a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VSnackbar})
